import { useSuspenseQuery } from '@apollo/client';
import { gql } from '@/__generated__';

export const STREAM_POSTS_PAGE_SIZE = 20;

export const StreamPostsQuery = gql(`
  query StreamPostsQuery($id: ID!, $limit: Int!, $nextToken: String) {
    streamPosts(id: $id, limit: $limit, nextToken: $nextToken) {
      items {
        ... on StreamPost {
          ...StreamPostCardFragment
        }
      }
      nextToken
    }
  }
  `);

export const useStreamPosts = (id: string) => {
  return useSuspenseQuery(StreamPostsQuery, {
    variables: {
      id,
      limit: STREAM_POSTS_PAGE_SIZE,
      nextToken: null,
    },
    fetchPolicy: 'cache-and-network',
  });
};
